// extracted by mini-css-extract-plugin
export default {"container":"option_container__M5Lz9","inner":"option_inner__uKmup","img-container":"option_img-container__GXoyf"};